
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const entitycategories = state => state.entitycategories;
const getsingle = state => param =>state.entitycategories.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  entitycategories,
  getsingle
};